import {Component, input, output, ChangeDetectionStrategy} from "@angular/core"
import {Currency, PricedItem} from "@cm/pricing"
import {CurrencyPipe} from "@angular/common"
import {MatTooltipModule} from "@angular/material/tooltip"

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: "cm-price-table",
    templateUrl: "./price-table.component.html",
    styleUrls: ["./price-table.component.scss"],
    imports: [CurrencyPipe, MatTooltipModule],
})
export class PriceTableComponent {
    readonly $items = input.required<PricedItem[]>({alias: "items"})
    readonly $error = input.required<string>({alias: "error"})
    readonly $currencies = input<Currency[]>([], {alias: "currencies"})
    readonly $selectedCurrency = input<Currency | undefined>(undefined, {alias: "selectedCurrency"})
    readonly selectedCurrencyChange = output<Currency>()
    readonly $priceIncludesVat = input<boolean>(true, {alias: "priceIncludesVat"})

    onCurrencyChange(event: Event) {
        const value = (event.target as HTMLSelectElement).value as Currency
        this.selectedCurrencyChange.emit(value)
    }
}
